import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class MoneySourceInsertService {

  private apiUrl = globalConst.baseAPI;
  constructor(private http: Http) { }

  insertMoneySource(token, moneySource: any) {
  	return this.http
  	.post(this.apiUrl + "moneysource/v1/insert", moneySource, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  	.map((res: Response) => res.json())
  	.catch(e => {
  		if (e.status === 401) {
  			return Observable.throw('Unauthorized');
  		}
  	});
  }

}



// WEBPACK FOOTER //
// ./src/app/money-source/service/money-source-insert/money-source-insert.service.ts